<template>
    <div>
        <v-dialog v-model="register_dialog" persistent max-width="600px">
            <v-btn class="hidden-sm-and-down" flat style="height:100%;width:15vw;padding:0;" slot="activator"><v-img :src="row1_img2" /></v-btn>
            <v-btn class="hidden-md-and-up" flat style="height:100%;width:32vw;padding:0;" slot="activator"><v-img :src="row1_img2" /></v-btn>
            <v-card>
            <v-card-title>
                <span class="headline">{{title}}</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field v-model="name" required>
                            <template v-slot:label>
                            {{lbl_name}}
                            </template>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field v-model="email" required>
                            <template v-slot:label>
                            {{lbl_email}}
                            </template>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field v-model="password" type="password" required>
                            <template v-slot:label>
                            {{lbl_password}}
                            </template>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field v-model="confirmpassword" label="Confirmar contraseña" type="password" required>
                            <template v-slot:label>
                            {{lbl_confirm_password}}
                            </template>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field v-model="license" label="Codigo" required>
                            <template v-slot:label>
                            {{lbl_code}}
                            </template>
                        </v-text-field>
                    </v-flex>                          
                </v-layout>
                </v-container>
                <small></small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="register_dialog = false">{{close}}</v-btn>
                <v-btn color="blue darken-1" flat @click="register">{{register_text}}</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>    
</template>



<script>
import { uuid } from 'vue-uuid';

let language=localStorage.getItem('language');
export default {
    data(){
        if (language=='es-XL' || language=='es')
        {
            return{
                dialog:false,
                title:'Registro',
                register_dialog: false,
                row1_img2:'./btn_registrate.png',
                row1_img1:'./btn__iniciarsesion.png',
                close:'Cerrar',
                register_text:'REGISTRARME',
                name:'',
                email:'',
                password:'',
                license:'',
                confirmpassword:'',
                lbl_name:'Nombre',
                lbl_email:'Email',
                lbl_password:'Contraseña',
                lbl_confirm_password:'Confirmar Contraseña',
                lbl_code:'Codigo',
            }
        }else{
            return{
                dialog:false,
                title:'Register',
                register_dialog: false,
                row1_img2:'./registrate_eng.png',
                close:'Close',
                register_text:'Register',
                name:'',
                email:'',
                password:'',
                license:'',
                confirm_password:'',
                lbl_name:'Name',
                lbl_email:'Email',
                lbl_password:'Password',
                lbl_confirm_password:'Confirm Password',
                lbl_code:'Code',   
            }
        }
    },
    methods:{
      register: function () {
          if (this.password != this.confirm_password) {
              alert("contraseñas no coinciden");
              return;
          }
        let id = uuid.v1();
        let data = {
          name: this.name,
          email: this.email,
          password: this.password,
          license: this.license,
          id_only: id,
          client_id:'5c6c4ada410dfba504749c41',
          platform:'windows'
        }
        this.$store.dispatch('register', data)
        .then(() =>         
        this.$router.push('/padres-descargas')        
        )
        .catch(function () {
           alert("Hubo un problema");
       })
      }
    }  

}
</script>